import { render } from "./ConfirmImage.vue?vue&type=template&id=2dee57f1&scoped=true"
import script from "./ConfirmImage.vue?vue&type=script&lang=js"
export * from "./ConfirmImage.vue?vue&type=script&lang=js"

import "./ConfirmImage.vue?vue&type=style&index=0&id=2dee57f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dee57f1"]])

export default __exports__